import * as React from "react";
import * as moment from "moment";
import { __, __BETA, __TRIAL_DATE } from "src/services/theme";

const HTML = (props) => (
    <section className="info">
    
      <header>
        <div className="container">
          <h1>Premium visor</h1>
          <p>
            Una scheda dettagliata e ricca di funzioni.<br />
            Informazioni aggiuntive e dettagliate convertono le visite in clienti potenziali con un incremento del 95%.
          </p>
        </div>
      </header>
      
      <a id="trial" />
      <div className="cta gopremium">
        <div className="container">
          {props.trialStatus !== "active" &&
          <h2>
            Prova Premium Gratis 
            {__TRIAL_DATE &&
            <small>fino al {moment(__TRIAL_DATE).format('DD/MM/YYYY')}</small>
            }
          </h2>
          }
          <article>
            {!props.trialStatus &&
            <button className="main2 xl" onClick={() => { props.onTrial(); }}><span>Prova Premium</span></button>
            }
            {props.trialStatus === "loading" &&
            <button className="cancel xl"><span>Attivando</span></button>
            }
            {props.trialStatus === "active" &&
            <button className="main3 xl" onClick={() => { props.onEdit(); }}><span>Free trial attivata: <strong>Vai alla tua Scuola</strong></span></button>
            }
          </article>
          <br />
          <p>Al termine della prova potrai sottoscrivere l'abbonamento mensile</p>
        </div>
      </div>
      
      <div className="features container">
        <h2><span>Caratteristiche</span></h2>
        <p>
        Tutte le caratteristiche del pacchetto <strong>FREE</strong>
        </p>
        <ul className="icons">
          <li>
            <span><span><span className="icon-contact_card" /></span></span>
            <span><strong>Anagrafica</strong></span>
          </li>
          <li>
            <span><span><span className="icon-marker" /></span></span>
            <span><strong>Tasto “Raggiungi Sede”</strong> su mobile</span>
          </li>
          <li>
            <span><span><span className="icon-news" /></span></span>
            <span><strong>Descrizione</strong> scuola</span>
          </li>
          <li>
            <span><span><span className="icon--phone" /></span></span>
            <span><strong>Tasto "Chiama"</strong> su mobile</span>
          </li>
          <li>
            <span><span><span className="icon-mail" /></span></span>
            <span><strong>Assistenza</strong> via email</span>
          </li> 
          <li>
            <span><span><span className="icon-talk" /></span></span>
            <span><strong>Richiesta contatto</strong> nella scheda</span>
          </li>        
        </ul>
        <p>
        Più gli optional del pacchetto <strong>PREMIUM</strong>
        </p>
        <ul className="icons2">
          <li>
            <span><span><span className="icon-picture" /></span></span>
            <span><strong>12 Foto</strong> inseribili nella scheda</span>
          </li>
          <li>
            <span><span><span className="icon-event_accepted" /></span></span>
            <span><strong>Eventi</strong> inseribili nella scheda</span>
          </li>
          <li>
            <span><span><span className="icon-racism_filled" /></span></span>
            <span><strong>Open Day</strong> inseribili nella scheda</span>
          </li>
          <li>
            <span><span><span className="icon-restaurant_menu" /></span></span>
            <span><strong>Menù mensa</strong> inseribili nella scheda</span>
          </li>
          <li>
            <span><span><span className="icon-open_file_under_cursor" /></span></span>
            <span><strong>Documenti</strong> inseribili nella scheda</span>
          </li> 
          <li>
            <span><span><span className="icon-very_popular_topic" /></span></span>
            <span><strong>Recensione preferita</strong> in testa alla scheda</span>
          </li>        
        </ul>
      </div>
      
      <a id="premium" />
      {!__BETA &&
      <div className="cta gopremium">
        <div className="container">
          <h2>Sottoscrivi abbonamento</h2>
          <p>&euro;360/anno. Abbonamento annuale prepagato.</p>
          <article>
            <span className="price">
              <small>&euro;</small>
              <strong>0,99</strong>
              <span>/giorno</span>
            </span>
            
            {!props.activated &&
            <button className="main2" onClick={() => { self.location.href = '#up'; props.onClick(); }}><span>Sottoscrivi</span></button>
            }
            {props.activated &&
            <button className="main2" disabled><span>Già attivato</span></button>
            }
          </article>
        </div>
      </div>
      }
      
      <div className="faq container">
        <h2><span>Domande frequenti</span></h2>
        <div className="items">
          <article>
            <h4>{__('AcquistiScuolaPremium.faq1_title')}</h4>
            <p>{__('AcquistiScuolaPremium.faq1_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaPremium.faq2_title')}</h4>
            <p>{__('AcquistiScuolaPremium.faq2_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaPremium.faq3_title')}</h4>
            <p>{__('AcquistiScuolaPremium.faq3_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaPremium.faq4_title')}</h4>
            <p>{__('AcquistiScuolaPremium.faq4_text', 130)}</p>
          </article>
        </div>
      </div>
      
    </section>
);

export default HTML;


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiScuolaInfo/Premium.tsx